import { useFormContext } from 'react-hook-form';

import {
  ControlledCheckbox,
  ControlledRadioGroup
} from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import InputAdornment from '@mui/material/InputAdornment';

const t = i18n.getFixedT(getLocale(), 'common');

enum HM_SETTINGS_FLAG {
  SHOW_MORE_HOURS_WITH_MINUS_SIGN = 'SHOW_MORE_HOURS_WITH_MINUS_SIGN',
  SHOW_MORE_HOURS_WITH_PLUS_SIGN_AND_MINUS_HOURS_WITH_MINUS_SIGN = 'SHOW_MORE_HOURS_WITH_PLUS_SIGN_AND_MINUS_HOURS_WITH_MINUS_SIGN'
}

const HourManagementFormContent = () => {
  const { control } = useFormContext();
  const hmOptions = [
    {
      value: HM_SETTINGS_FLAG.SHOW_MORE_HOURS_WITH_MINUS_SIGN,
      label: t('hourManagementSettings.hourManagement.withMinusSignOption')
    },
    {
      value:
        HM_SETTINGS_FLAG.SHOW_MORE_HOURS_WITH_PLUS_SIGN_AND_MINUS_HOURS_WITH_MINUS_SIGN,
      label: t('hourManagementSettings.hourManagement.withPlusSignOption')
    }
  ];

  return (
    <>
      <MultiStepForm.Section title={t('hourManagementSettings.wab.title')}>
        <ControlledNumericField
          name="warningPercentage.value"
          label={t('hourManagementSettings.wab.warningPercentage')}
          helperText={t('hourManagementSettings.wab.validRange')}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>
          }}
        />
        <ControlledNumericField
          name="alertPercentage.value"
          label={t('hourManagementSettings.wab.alertPercentage')}
          helperText={t('hourManagementSettings.wab.validRange')}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>
          }}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section
        title={t('hourManagementSettings.hourManagement.title')}
      >
        <ControlledRadioGroup
          control={control}
          name="hourManagementSettingsSchema.0.value"
          label={''}
          options={hmOptions}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section
        title={t('hourManagementSettings.yearClosure.title')}
      >
        <ControlledCheckbox
          control={control}
          name="yearClosureSettingsSchema.value"
          label={t('hourManagementSettings.yearClosure.enableAdHocCalculation')}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section
        title={t('hourManagementSettings.balanceBudget.title')}
      >
        <ControlledCheckbox
          control={control}
          name="balanceBudgetPlb.value"
          label={t('hourManagementSettings.balanceBudget.depositFromPlb')}
        />
        <ControlledCheckbox
          control={control}
          name="balanceBudgetAllYears.value"
          label={t('hourManagementSettings.balanceBudget.depositFromAllYears')}
        />
      </MultiStepForm.Section>
    </>
  );
};

export default HourManagementFormContent;
